import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import MoviesPage from "../pages/movies/page";
import MovieDetailPage from "../pages/movie/page";
import NewsPage from "../pages/news/page";
import NewsDetailPage from "../pages/news/detail/page";
import SpecialsPage from "../pages/specials/page";
import SpecialDetailPage from "../pages/specials/detail/page";
import AboutPage from "../pages/about/page";
import SearchPage from "../pages/search/page";

const routes: RouteObject[] = [
  {
    element: <SiteLayout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/movies",
        element: <MoviesPage />,
      },
      {
        path: "/movie/:id",
        element: <MovieDetailPage />,
      },
      {
        path: "/news",
        element: <NewsPage />,
      },
      {
        path: "/news/:id",
        element: <NewsDetailPage />,
      },
      {
        path: "/specials",
        element: <SpecialsPage />,
      },
      {
        path: "/specials/:id",
        element: <SpecialDetailPage />,
      },
      {
        path: "/about",
        element: <AboutPage />,
      },
      {
        path: "/search",
        element: <SearchPage />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;